<article class="keyword {{ word?.correct ? 'correct' : '' }}">
  <table>
    <tr class="sub top" *ngIf="word.intonation || word.fourTones">
      <td *ngFor="let cs of word.wordStruct"
          class="{{ GetSeungjoClass(cs) }}">{{ GetSaseungTxt(cs) }}</td>
    </tr>
    <tr class="main">
      <td *ngFor="let cs of word.wordStruct; let idx = index"
          class="{{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}">
        <ng-template #notHanja>
          {{ GetCharTxt(cs) }}
        </ng-template>
        <app-hanja-char *ngIf="IsHanja(cs) && select; else notHanja"
                        class="{{ GetCharClass(cs) }} {{ GetHightlightClass(idx) }}"
                        [hanja]="GetCharTxt(cs)"></app-hanja-char>
      </td>
      <td *ngIf="word.idxHomonym > 0"
          class="idx-homonym">{{ word.idxHomonym }}</td>
    </tr>
    <!-- 아래는 사용 안 하기로 변경됨 -->
    <!-- tr class="sub bottom">
      <td *ngFor="let cs of word.wordStruct"
          class="{{ GetSeungjoClass2(cs) }}"></td>
    </tr -->
  </table>

  <div *ngIf="word?.correct">
    <div class="correct">
      <div class="arrow">{{ arrowCorrect }}</div>
      <div class="txt"
           *ngIf="!select || !word.correctIds">{{ wordCorrect }}</div>
      <div class="txt link"
           *ngIf="select && word.correctIds"
           (click)="onClickCorrect($event)">{{ wordCorrect }}</div>
    </div>
  </div>


  <!-- button *ngIf="word.wordVoice"
          type="button" class="sound-btn"
          (click)="playSound($event, word.wordVoice)"></button -->

</article>
